export default __webpack_public_path__ + "static/media/jld_icon.752226d0.gif";